import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Popper from '@material-ui/core/Popper';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Typography from '@material-ui/core/Typography';
import Slider from '@material-ui/core/Slider';
import { Icon } from '@material-ui/core';

const NIGHTS_DEFAULT = 3

class StayFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      nights: this.props.nights || NIGHTS_DEFAULT,
      open: false
    };
  }

  handleToggle = () => {
    this.setState(state => ({ open: !state.open }));
  }

  handleChange = (event, nights) => {
    this.setState({ nights });
  };


  handleClose = event => {
    this.setState({ open: false })
    this.props.onChange({
      nights: this.state.nights
    })
  }

  renderButtonLabel() {
    // if (this.state.nights !== 2) {
      return this.state.nights + ' night' + (this.state.nights > 1 ? 's' : '')
    // } else {
    //   return 'Time of stay'
    // }
  }

  render() {
    const { classes } = this.props;
    const { open, nights } = this.state;

    return(
      <div className={classes.root}>
        <Button
          buttonRef={node => {
            this.anchorEl = node;
          }}
          aria-owns={open ? 'travelers-list-grow' : null}
          aria-haspopup="true"
          name="Filter: Length of stay in days"
          onClick={this.handleToggle}
          className={open || this.state.nights !== NIGHTS_DEFAULT ? classes.selected : classes.select}>
          <Icon className={[classes.icon, "material-icons-outlined notranslate"]}>access_time</Icon>
          {this.renderButtonLabel(this)}
          <Icon className={classes.iconArrow}>keyboard_arrow_down</Icon>
        </Button>
        <Popper open={this.state.open}
          anchorEl={this.anchorEl}
          className={classes.popper}
          placement="bottom-start"
          disablePortal={false}
          modifiers={{
            flip: {
              enabled: false,
            },
            preventOverflow: {
              enabled: true,
              boundariesElement: 'window',
            },
            arrow: {
              enabled: false,
              element: this.anchorEl,
            },
          }}>
          <ClickAwayListener onClickAway={this.handleClose}>
            <List className={classes.list}>
              <ListItem className={classes.listItem}>
                <Typography className={classes.label} id="label">Time of stay: <b>{nights}</b> night{(this.state.nights > 1 ? 's' : '')}</Typography>
                <Slider
                  value={nights}
                  min={1}
                  max={30}
                  step={1}
                  aria-labelledby="label"
                  onChange={this.handleChange}
                  classes={{
                    track: classes.track,
                    thumb: classes.thumb
                  }} />
             </ListItem>
            </List>
          </ClickAwayListener>
        </Popper>
      </div>
    )
  }
}

const styles = theme => ({
  popper: {
    top: '7px !important',
    // left: '0px !important',
    // marginTop: 40,
    // marginLeft: 20,
    // textAlign: 'left',
    // position: 'fixed !important',
    // zIndex: 2,
  },
  root: {
    fontSize: 12,
    color: 'rgba(0, 0, 0, 0.87)',
    display: 'inline-flex',
    position: 'relative',
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
    lineHeight: '1.4em',
    marginRight: 10,
    marginTop: 5,
    textAlign: 'left',
  },
  select: {
    color: '#777',
    fontWeight: 400,
    // backgroundColor: '#eee',
    fontSize: 12,
    padding: '1px 8px 0px 8px',
    borderRadius: 25,
    // border: '1px solid #eee',
    height: 40,
    textTransform: 'none !important',
    textAlign: 'left',
    minWidth: 90,

    '&:focus': {
      borderRadius: 25,
    }
  },
  selected: {
    color: '#333',
    fontWeight: 600,
    fontSize: 12,
    // backgroundColor: '#5ad076',
    padding: '1px 8px 0px 8px',
    // border: '1px solid #eee',
    height: 40,
    borderRadius: 25,
    textTransform: 'none !important',
    textAlign: 'left',
    minWidth: 90,

    '&:focus': {
      // backgroundColor: '#5ad076',
      borderRadius: 25,
    },
    '&~svg': {
      color: '#fff',
    },
    '&:hover': {
      // backgroundColor: '#5ad076',
      borderRadius: 25,
      color: '#333',
    },
  },
  list: {
    maxWidth: 300,
    minWidth: 300,
    boxShadow: '0 10px 20px 0 rgb(0 0 0 / 5%)',
    border: '1px solid #f5f5f5',
    borderRadius: 25,
    // borderRadius: 3,
    backgroundColor: '#fff',
    padding: 0,
    marginRight: 10,
  },
  listItem: {
    display: 'block',
    padding: '30px 30px 30px 22px',
    minWidth: 300,
    maxWidth: 300
  },
  label: {
    padding: '0px 0px 10px 0px',
    fontSize: 14,
  },
  thumb: {
    backgroundColor: '#02c39a',
    width: 20,
    height: 20,
    marginTop: '-9px !important',
  },
  track: {
    backgroundColor: '#02c39a'
  },
  icon: {
    marginRight: 5,
    fontSize: 18,
    marginTop: -3,
    padding: '0px !important',
  },
  iconArrow: {
    margin: '0 0 0 3px',
    fontSize: 18,
    padding: '0px !important',
  },
});

export default withStyles(styles)(StayFilter);